const fleetListGridlet = {
  bindings: {
    settings: '<',
    area: '<',
    gridlet: '<',
    fleet: '<',
    dataLoading: '<',
    onTrainSelect: '&',
    filter: '<',
  },
  templateUrl: '/modules/gridlets/fleet-list-gridlet/fleet-list-gridlet.html',
  controller: 'FleetListGridletController',
};

angular
  .module('gridlets.module')
  .component('fleetListGridlet', fleetListGridlet);